module.exports = __webpack_public_path__ + "static/media/vico.736ed134.jpg";